import axios from 'axios';
import apiUrl from '../utility/apiUrl';

class ArticleService {

    getArticles(params) {
        return axios.get(`${apiUrl}/api/v1/article/list`, { params });
    }

    getArticleBySlug(slug) {
        return axios.get(`${apiUrl}/api/v1/article/${slug}`);
    }

    recordView(slug) {
        return axios.post(`${apiUrl}/api/v1/article/${slug}/view`);
    }

    getArticlesByTag(tagSlug, params) {
        return axios.get(`${apiUrl}/api/v1/article/tag/${tagSlug}`, { params });
    }

    getArticlesByCategory(categoryId, params) {
        return axios.get(`${apiUrl}/api/v1/article/category/${categoryId}`, { params });
    }

    getExperts(params) {
        return axios.get(`${apiUrl}/api/v1/expert/list`, { params });
    }

    getExpertBySlug(slug) {
        return axios.get(`${apiUrl}/api/v1/expert/${slug}`);
    }
}

export default new ArticleService();
